import {
  SectionTitle,
  Title,
  Image,
  Statistics,
  Statistic,
  Value,
  SubValue,
  EmptyState,
  Link,
  Button,
  SubMetric,
  ComparisonBox,
  CurrencyText,
  PreviousPeriod,
  StatisticHeader,
  DotWrapper,
  Dot,
} from "./styles";
import Grid from "../../../../components/Grid";
import { connect, useDispatch } from "react-redux";
import { Metric } from "../../../../types/community-metric";
import { useEffect, useRef, useState } from "react";
import { getCommunityMetrics } from "../../../../store/actions/community";
import numberFormater from "../../../../helpers/numberFormater";
import { formatPrice } from "../../../../helpers/price-formatter";
import { useWindowSize } from "../../../../hooks/useWindowSize";
import React from "react";

interface ComponentProps {
  metrics: Metric[];
  metricsObj: {
    type: string;
    image: string;
    title: string;
    emptyState: {
      text: string;
      cta: {
        label: string;
        href?: string;
        onClick?: () => void;
      };
    };
  }[];
  showPreviousPeriod: boolean | null;
  previousMonthName?: string | null;
  actions?: {
    label?: string;
    href?: string;
    onClick?: () => void;
  }[];
}

const Component = ({ metricsObj, metrics, actions, previousMonthName, showPreviousPeriod = false }: ComponentProps) => {
  const dispatch = useDispatch();
  const { isMobile } = useWindowSize();
  const [currentIndex, setCurrentIndex] = useState(0);
  const statisticsRef = useRef<HTMLDivElement>(null);

  // Efecto para detectar el scroll y actualizar el índice actual
  useEffect(() => {
    const el = statisticsRef.current;
    if (!el || !isMobile) return;

    const handleScroll = () => {
      if (!el) return;

      const scrollLeft = el.scrollLeft;
      const itemWidth = el.scrollWidth / metricsObj.length;
      const index = Math.round(scrollLeft / itemWidth);
      setCurrentIndex(index);
    };

    el.addEventListener("scroll", handleScroll);
    return () => el.removeEventListener("scroll", handleScroll);
  }, [isMobile, metricsObj.length]);

  const getMetric = (type) => {
    if (!!metrics && metrics.length > 0) {
      const metric = metrics?.filter((metric) => metric.type === type);
      if (!!metric && metric.length > 0) {
        const metricData = metric[0];
        const totalValue = Number(metricData.total || 0);

        if (metricData.currency) {
          return (
            <span>
              <span style={{ fontSize: "20px" }}>$</span>
              {metricData.members_count || formatPrice(totalValue)}
              <span style={{ fontSize: "20px" }}>{metricData.currency}</span>
            </span>
          );
        } else {
          return metricData.members_count || totalValue;
        }
      }
    }

    return 0;
  };

  const getSubMetric = (type) => {
    if (!!metrics && metrics.length > 0) {
      const metric = metrics?.filter((metric) => metric.type === type);

      if (!metric[0]?.previous_period_total)
        metric[0].previous_period_total = 0

      if (!!metric && metric.length > 0) {
        return (
          <SubMetric>
            <div>
              <ComparisonBox
                isGreatherThanPreviousPeriod={metric[0].type === "membership_third_kpi" ? Number(metric[0].total || 0) <= Number(metric[0].previous_period_total || 0) : Number(metric[0].total || 0) >= Number(metric[0].previous_period_total || 0)}
              >
                {metric[0].previous_period_total === metric[0]?.total ? "" : Number(metric[0]?.previous_period_total || 0) > Number(metric[0]?.total) ? "↓" : "↑"}
                {/*metric[0].previous_period_total === metric[0]?.total ? "" : Number(metric[0]?.previous_period_total || 0) > Number(metric[0]?.total) ? metric[0].type === "membership_third_kpi" ? "↑" : "↓" : metric[0].type === "membership_third_kpi" ? "↓" : "↑"*/}
                {metric[0].previous_period_total === metric[0]?.total ? "0" : Number(metric[0]?.previous_period_total || 0) === 0 ? "∞" : Math.abs(Math.floor((1 - (Number(metric[0]?.total) / Number(metric[0]?.previous_period_total))) * 100))}
                {" "}%
              </ComparisonBox>
            </div>
            <PreviousPeriod>vs. {previousMonthName}: <CurrencyText>{metric[0]?.currency ? "$" : ""}</CurrencyText>{metric[0]?.currency ? formatPrice(Number(metric[0]?.previous_period_total)) : metric[0]?.previous_period_total?.toString()} <CurrencyText>{metric[0]?.currency ? metric[0]?.currency : ""}</CurrencyText></PreviousPeriod>
          </SubMetric>
        )
      }
    }

    return <PreviousPeriod>vs. {previousMonthName}: 0</PreviousPeriod>;
  };

  const Action = ({ index, defaultAction }) => {
    const label =
      !!actions && !!actions[index]?.label
        ? actions[index]?.label
        : defaultAction?.label;

    const href =
      !!actions && !!actions[index]?.href
        ? actions[index]?.href
        : defaultAction?.href;

    const onClick =
      !!actions && !!actions[index]?.onClick
        ? actions[index]?.onClick
        : defaultAction?.onClick;

    return !!onClick ? (
      <Button type="button" onClick={() => onClick()}>
        {label}
      </Button>
    ) : (
      <Link to={href}>{label}</Link>
    );
  };

  useEffect(() => {
    dispatch(getCommunityMetrics());
  }, []);

  const validMetricValues = metricsObj.map(x => getMetric(x.type)).filter(y => y && Number(y) > 0)

  return (
    <Grid.Container>
      <Statistics ref={statisticsRef}>
        {metricsObj.map((metricOnj, index) => {
          return (
            <>
              <Statistic key={`metric-${metricOnj.type}`} isEmpty={validMetricValues.length <= 0}>
                {validMetricValues.length <= 0 ? (
                  <>
                    <StatisticHeader>
                      <Title>{metricOnj.title}</Title>
                    </StatisticHeader>

                    <div style={{ height: "14px" }} />

                    <EmptyState>
                      <Image
                        src={metricOnj.image}
                        width="44px"
                        height="46px"
                      />

                      <div>
                        <p>{metricOnj.emptyState.text}</p>

                        <Action
                          index={index}
                          defaultAction={metricOnj.emptyState.cta}
                        />
                      </div>
                    </EmptyState>
                  </>
                ) : (
                  <>
                    <StatisticHeader>
                      <Title>{metricOnj.title}</Title>
                    </StatisticHeader>
                    <div style={{ height: "14px" }} />
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 12 }}>
                      <Image
                        src={metricOnj.image}
                        width="44px"
                        height="46px"
                      />
                      <Value>
                        {(() => {
                          const metricValue = getMetric(metricOnj.type);
                          // Si es un JSX element (con currency), renderizarlo directamente
                          if (React.isValidElement(metricValue)) {
                            return metricValue;
                          }
                          // Si es un número, aplicar toLocaleString
                          return Number(metricValue || 0).toLocaleString('en-US');
                        })()}
                      </Value>
                    </div>
                    <div style={{ height: "14px" }} />
                    {showPreviousPeriod && (
                      <SubValue>{getSubMetric(metricOnj.type)}</SubValue>
                    )}
                  </>
                )}
              </Statistic>
            </>
          );
        })}
      </Statistics>

      {isMobile && (
        <DotWrapper>
          {Array.from({ length: metricsObj.length }).map((_, i) => (
            <Dot key={i} active={i === currentIndex} />
          ))}
        </DotWrapper>
      )}
    </Grid.Container>
  );
};

export default Component;
